import { EntityBase } from './EntityBase';
import { TypeChangeReportTopic } from './TypeChangeReportTopic';
import { UserChangeReport } from './UserChangeReport';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class UserChangeReportTopic extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   userChangeReportTopicId: number;
   userChangeReportId: number;
   typeChangeReportTopicId: string;
   enabled: boolean;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   typeChangeReportTopic: TypeChangeReportTopic;
   userChangeReport: UserChangeReport;
}

